'use strict';

var ciphers = require('./ciphers');

var CIPHER_MODES = {
  16: 'aes-128-ctr',
  32: 'aes-256-ctr'
};

exports.create = function (key, iv, callback) {
  var mode = CIPHER_MODES[key.length];

  if (!mode) {
    return callback(new Error('Invalid key length'));
  }

  var cipher = ciphers.createCipheriv(mode, key, iv);
  var decipher = ciphers.createDecipheriv(mode, key, iv);
  var res = {
    encrypt: function encrypt(data, cb) {
      cb(null, cipher.update(data));
    },
    decrypt: function decrypt(data, cb) {
      cb(null, decipher.update(data));
    }
  };
  callback(null, res);
};